import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useLayoutEffect, useState, useMemo, useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import screens from '../..';
import useFeatureFlags from '../../../hooks/useFeatureFlags';
import useNavState from '../../../hooks/useNavState';
import { useGetBattlesAndMissionsQuery } from '../../../state/query/unifiedQuerys/battlesMissions';
import { FE_BATTLES, FE_MISSIONS } from '../../../utils/featureFlags/constants';
import QueryParamProxy from '../../../utils/queryParamProxy';
import { getTimestamp } from '../../../utils/TimestampManager';
import { sendMissionsEvent } from '../analytics/missionsLogger';
import { MISSIONS_EVENT_TYPES, MISSIONS_STATES, MISSIONS_TYPES } from '../constants';
import { selectCurrentMissionType } from '../selectors';
import { hasCurrentMissionBattles, hasExplorerType, hasGrandType, hasSomeCompleteState } from '../utils/missionsPerformance';
var useMissionsRequest = function useMissionsRequest(_ref) {
  var navigation = _ref.navigation,
    activeTutorial = _ref.activeTutorial;
  var _useFeatureFlags = useFeatureFlags(),
    hasFeature = _useFeatureFlags.hasFeature;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    pollingInterval = _useState2[0],
    setPollingInterval = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showTabs = _useState4[0],
    setShowTabs = _useState4[1];
  var currentMissionType = useSelector(selectCurrentMissionType, shallowEqual);
  useLayoutEffect(function () {
    if (!hasFeature(FE_MISSIONS)) QueryParamProxy.navigate(navigation, screens.Home);
    if (hasCurrentMissionBattles(currentMissionType) && !activeTutorial) QueryParamProxy.navigate(navigation, screens.Battles);
  }, [hasFeature, navigation, currentMissionType, activeTutorial]);
  useNavState();
  var _useGetBattlesAndMiss = useGetBattlesAndMissionsQuery({
      requestAssetsData: false
    }, {
      pollingInterval: pollingInterval
    }),
    _useGetBattlesAndMiss2 = _useGetBattlesAndMiss.data,
    _useGetBattlesAndMiss3 = _useGetBattlesAndMiss2 === void 0 ? {} : _useGetBattlesAndMiss2,
    _useGetBattlesAndMiss4 = _useGetBattlesAndMiss3.missions,
    missions = _useGetBattlesAndMiss4 === void 0 ? [] : _useGetBattlesAndMiss4,
    _useGetBattlesAndMiss5 = _useGetBattlesAndMiss3.missionsFeature,
    missionsFeature = _useGetBattlesAndMiss5 === void 0 ? {} : _useGetBattlesAndMiss5,
    _useGetBattlesAndMiss6 = _useGetBattlesAndMiss3.battlesSetup,
    battlesSetup = _useGetBattlesAndMiss6 === void 0 ? null : _useGetBattlesAndMiss6,
    isLoading = _useGetBattlesAndMiss.isLoading;
  useEffect(function () {
    sendMissionsEvent(MISSIONS_EVENT_TYPES.ENTER_MISSIONS_SCREEN);
    setShowTabs(hasFeature(FE_BATTLES) && battlesSetup);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [battlesSetup]);
  var handlePollingInterval = useCallback(function () {
    var endtimestamp = [];
    (missionsFeature === null || missionsFeature === void 0 ? void 0 : missionsFeature.endTimestamp) && endtimestamp.push(missionsFeature === null || missionsFeature === void 0 ? void 0 : missionsFeature.endTimestamp);
    missions === null || missions === void 0 || missions.forEach(function (item) {
      return !hasSomeCompleteState(item.missionStatus) && endtimestamp.push(item.endTimestamp);
    });
    var newInterval = getTimestamp(Math.min.apply(Math, endtimestamp));
    setPollingInterval(function (prev) {
      return prev !== newInterval ? newInterval : prev;
    });
  }, [missions, missionsFeature === null || missionsFeature === void 0 ? void 0 : missionsFeature.endTimestamp]);
  useEffect(handlePollingInterval, [handlePollingInterval]);
  var filteredValue = useMemo(function () {
    return (missions === null || missions === void 0 ? void 0 : missions.filter(function (mission) {
      return (hasExplorerType(mission.missionType) || hasGrandType(mission.missionType)) && mission.missionStatus !== MISSIONS_STATES.COMPLETED && mission.missionStatus !== MISSIONS_STATES.FINISHED;
    })) || [];
  }, [missions]);
  return useMemo(function () {
    return {
      filteredValue: filteredValue,
      filterData: MISSIONS_TYPES.EXPLORER,
      showTabs: showTabs,
      isLoading: isLoading,
      currentMissionType: currentMissionType
    };
  }, [filteredValue, showTabs, isLoading, currentMissionType]);
};
export default useMissionsRequest;